import React from "react";
import { useNavigate } from "react-router-dom";
import useAdminUsers from "./hooks/useAdminUsers";
import { AdminUserTable } from "./AdminUserList";
import AdminLatestNews from "./AdminLatestNews";
import AdminNewsletters from "./AdminNewsletters";
import AdminUpcomingEvents from "./AdminUpcomingEvents";
import AdminSocialMedia from "./AdminSocialMedia";
import AdminSocialMediaUpdates from "./AdminSocialMediaUpdates";
import AdminContactStaff from "./AdminContactStaff";
const Admin = () => {
  const {
    users,
    loading,
    error,
    removeUser,
    setAdmin,
    removeAdmin,
    setUserType,
    findRegionById,
  } = useAdminUsers();
  const navigate = useNavigate();
  const userType = localStorage.getItem("userType");
  const isAdmin = userType === "admin";
  const [activeTab, setActiveTab] = React.useState("users");

  if (!isAdmin) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
        <p>You do not have permission to view this page.</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
          onClick={() => navigate("/")}
        >
          Go Home
        </button>
      </div>
    );
  }

  if (loading)
    return (
      <div className="p-4 text-center">
        <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>
        <div className="flex justify-center mb-4" role="status" aria-live="polite">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" />
        </div>
        <p className="mb-6 text-gray-600">Loading data, please wait...</p>
      </div>
    );
  if (error)
    return (
      <div className="p-4 text-center">
        <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>
        <p className="mb-6 text-gray-600">{error}</p>
      </div>
    );

  return (
    <div className="p-4 text-center font-['corporate-s'] text-left">
      <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>

      <div className="mb-6 flex gap-2 flex-wrap">
        <button onClick={() => setActiveTab("users")} className={`px-4 py-2 rounded ${activeTab === "users" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          User List
        </button>
        <button onClick={() => setActiveTab("latestNews")} className={`px-4 py-2 rounded ${activeTab === "latestNews" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Latest News
        </button>
        <button onClick={() => setActiveTab("newsletters")} className={`px-4 py-2 rounded ${activeTab === "newsletters" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Newsletters
        </button>
        <button onClick={() => setActiveTab("upcomingEvents")} className={`px-4 py-2 rounded ${activeTab === "upcomingEvents" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Upcoming Events
        </button>
        <button onClick={() => setActiveTab("socialMedia")} className={`px-4 py-2 rounded ${activeTab === "socialMedia" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Social Media
        </button>
        <button onClick={() => setActiveTab("socialMediaUpdates")} className={`px-4 py-2 rounded ${activeTab === "socialMediaUpdates" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Social Media Updates
        </button>
        <button onClick={() => setActiveTab("contactStaff")} className={`px-4 py-2 rounded ${activeTab === "contactStaff" ? "bg-blue-600 text-white" : "bg-white border"}`}>
          Contact Staff
        </button>
      </div>

      {activeTab === "users" && (
        <AdminUserTable
          users={users}
          onDelete={removeUser}
          onMakeAdmin={setAdmin}
          onRemoveAdmin={removeAdmin}
          onChangeUserType={setUserType}
          findRegionById={findRegionById}
        />
      )}

      {activeTab === "latestNews" && (
        <div className="mt-4">
          <AdminLatestNews />
        </div>
      )}

      {activeTab === "newsletters" && (
        <div className="mt-4">
          <AdminNewsletters />
        </div>
      )}

      {activeTab === "upcomingEvents" && (
        <div className="mt-4">
          <AdminUpcomingEvents />
        </div>
      )}
      {activeTab === "socialMedia" && (
        <div className="mt-4">
          <AdminSocialMedia />
        </div>
      )}
      {activeTab === "socialMediaUpdates" && (
        <div className="mt-4">
          <AdminSocialMediaUpdates />
        </div>
      )}
      {activeTab === "contactStaff" && (
        <div className="mt-4">
          <AdminContactStaff />
        </div>
      )}
    </div>
  );
};

export default Admin;